// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { RulesSet } from '../Rules/RulesSet';
import { AlertNotification, AlertType, AlertTypeMap, getAlertConditionKey } from './AlertConstants';
import { HistoryType } from '../History/HistoryType';
export class AlertUtils {
    static AllowPlaceOrder() {
        const hideOE = Resources.isHidden('screen.Alerts.Action.PlaceOrder');
        return !hideOE && this.DataCache.isAllowedForMyUser(RulesSet.FUNCTION_ALERTS_PLACE_ORDER);
    }
    static GetAlertNotificationItems(value) {
        const item = [];
        if (this.DataCache.isAllowedForMyUser(RulesSet.FUNCTION_ALERTS_EMAIL)) {
            item.push({
                value: AlertNotification.EMAIL,
                text: Resources.getResource('screen.Alerts.Notify.Email'),
                checked: (value & AlertNotification.EMAIL) === AlertNotification.EMAIL
            });
        }
        if (this.DataCache.isAllowedForMyUser(RulesSet.FUNCTION_ALERTS_PUSH)) {
            item.push({
                value: AlertNotification.PUSH,
                text: Resources.getResource('screen.Alerts.Notify.Push'),
                checked: (value & AlertNotification.PUSH) === AlertNotification.PUSH
            });
        }
        item.push({
            value: AlertNotification.SHOW_POP_UP,
            text: Resources.getResource('screen.Alerts.Notify.Popup'),
            checked: (value & AlertNotification.SHOW_POP_UP) === AlertNotification.SHOW_POP_UP
        });
        item.push({
            value: AlertNotification.SOUND,
            text: Resources.getResource('screen.Alerts.Notify.Sound'),
            checked: (value & AlertNotification.SOUND) === AlertNotification.SOUND
        });
        return item;
    }
    static VerifyNotificationValue(value) {
        let verified = 0;
        if (this.DataCache.isAllowedForMyUser(RulesSet.FUNCTION_ALERTS_EMAIL) &&
            (value & AlertNotification.EMAIL) === AlertNotification.EMAIL) {
            verified += AlertNotification.EMAIL;
        }
        if (this.DataCache.isAllowedForMyUser(RulesSet.FUNCTION_ALERTS_PUSH) &&
            (value & AlertNotification.PUSH) === AlertNotification.PUSH) {
            verified += AlertNotification.PUSH;
        }
        if ((value & AlertNotification.SHOW_POP_UP) === AlertNotification.SHOW_POP_UP) {
            verified += AlertNotification.SHOW_POP_UP;
        }
        if ((value & AlertNotification.SOUND) === AlertNotification.SOUND) {
            verified += AlertNotification.SOUND;
        }
        return verified;
    }
    static GetDefaultAlertTypeByInstrument(instrument) {
        return AlertUtils.GetAlertType(instrument.HistoryType);
    }
    static GetAlertType(type) {
        switch (type) {
            case HistoryType.BID:
                return AlertType.BID;
            case HistoryType.QUOTE_TRADES:
                return AlertType.LAST;
            case HistoryType.ASK:
                return AlertType.ASK;
        }
    }
    static GetCorrectPriceForAlertByInstrument(instrument, historyType) {
        if (isNullOrUndefined(instrument)) {
            return NaN;
        }
        const Level1 = instrument.Level1;
        if (isNullOrUndefined(Level1)) {
            return NaN;
        }
        switch (historyType) {
            case HistoryType.BID:
                return Level1.GetBid();
            case HistoryType.ASK:
                return Level1.GetAsk();
            case HistoryType.LAST:
                return Level1.GetLastPrice();
            default:
                return Level1.GetBid();
        }
    }
    static GetValuesAndStates(value) {
        const res = {};
        if (this.DataCache.isAllowedForMyUser(RulesSet.FUNCTION_ALERTS_EMAIL)) {
            res[AlertNotification.EMAIL] = value & AlertNotification.EMAIL;
        }
        if (this.DataCache.isAllowedForMyUser(RulesSet.FUNCTION_ALERTS_PUSH)) {
            res[AlertNotification.PUSH] = value & AlertNotification.PUSH;
        }
        res[AlertNotification.SHOW_POP_UP] = value & AlertNotification.SHOW_POP_UP;
        res[AlertNotification.SOUND] = value & AlertNotification.SOUND;
        return res;
    }
    static GetMessageText(instrument, alertType, condition, valueFormatted, account) {
        const insName = instrument.DisplayName();
        const alertTypeText = Resources.getResource(`panel.watchlist.${AlertTypeMap[alertType]}`);
        const conditionText = Resources.getResource(getAlertConditionKey(condition));
        const accountText = `${Resources.getResource('general.trading.for')} ${account === null || account === void 0 ? void 0 : account.toString()}`;
        return `${insName} ${alertTypeText} ${conditionText} ${valueFormatted} ${accountText}`;
    }
}
AlertUtils.DataCache = null;
